import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

// ── Request schemas ──────────────────────────────────────────

/** POST /feedAdmin — administer a feed to a patient */
export const AdministerFeedRequestSchema = z.object({
  patient_id:           uuidSchema.optional(),
  mrn:                  z.string().min(1).max(50).optional(),
  container_identifier: z.string().min(1),   // BTL-P pattern from feed_preparations
}).refine(
  (d) => d.patient_id || d.mrn,
  { message: 'Either patient_id or mrn must be provided' },
);
export type AdministerFeedRequest = z.infer<typeof AdministerFeedRequestSchema>;

// ── Response schemas ─────────────────────────────────────────

export const SafetyCheckResultSchema = z.object({
  patient_link_passed:   z.boolean(),
  npo_check_passed:      z.boolean(),
  allergen_check_passed: z.boolean(),
  expiry_check_passed:   z.boolean(),
  recall_check_passed:   z.boolean(),
});
export type SafetyCheckResult = z.infer<typeof SafetyCheckResultSchema>;

/** Shape returned after successful feed administration */
export const AdministerFeedResponseSchema = z.object({
  verification_id:      uuidSchema,
  delivery_id:          uuidSchema,
  patient_id:           uuidSchema,
  container_identifier: z.string(),
  prep_id:              uuidSchema,
  order_type:           z.string(),
  verification_result:  z.string(),
  delivery_status:      z.string(),
  prep_status:          z.string(),
  safety_checks:        SafetyCheckResultSchema,
  administered_at:      z.string(),
});
export type AdministerFeedResponse = z.infer<typeof AdministerFeedResponseSchema>;

// ── GET /feedAdmin/deliveries — list deliveries ──────────────
// hospital_id is resolved by the controller from the caller's decrypted token
// (getScopeId), not a client-supplied query param.

export const DeliveryListQuerySchema = z.object({});
export type DeliveryListQuery = z.infer<typeof DeliveryListQuerySchema>;

export const DeliveryListItemSchema = z.object({
  delivery_id:          uuidSchema,
  patient_id:           uuidSchema.nullable(),
  patient_name:         z.string(),
  mrn:                  z.string(),
  feed_id:              uuidSchema,
  order_identifier:     z.string().nullable(),
  container_identifier: z.string().nullable(),
  feed_time:            z.string().nullable(),
  order_date:           z.string().nullable(),
  volume_ml:            z.string().nullable(),
  status:               z.string(),
});
export type DeliveryListItem = z.infer<typeof DeliveryListItemSchema>;
